import { render, staticRenderFns } from "./Demanda.vue?vue&type=template&id=b7058c18&scoped=true&"
import script from "./Demanda.vue?vue&type=script&lang=js&"
export * from "./Demanda.vue?vue&type=script&lang=js&"
import style0 from "./Demanda.vue?vue&type=style&index=0&id=b7058c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7058c18",
  null
  
)

export default component.exports